import React, { useEffect, useState } from 'react';
import { isFinishedFetching, ResourcesList } from 'redux-and-the-rest';
import { connect } from 'react-redux';

import { loadImage } from './utils';
import { ApplicationState } from '../../redux/types';
import { getOrFetchRewardPositions } from '../../redux/reducers/rewardPositionReducer';
import { RewardPositionModel } from '../../models/rewardPositionModel';
import { IslandModel } from '../../models/islandModel';
import { getUser } from '../../redux/reducers/userReducer';
import LoadingIndicator from '../shared/LoadingIndicator';
import IslandScene from './IslandScene';

interface Props extends OwnProps {
  rewardPositions: ResourcesList<RewardPositionModel>,
}

interface OwnProps {
  island: IslandModel,
}

const Island = ({ rewardPositions, island }: Props): React.ReactElement => {
  const [rewardsImageDownloaded, setRewardsImageDownloaded] = useState(false);
  const [rewardImageUrls, setRewardImageUrls] = useState<{ imageUrl: string}[]>([]);

  const {
    theme: {
      imageUrl: islandImageUrl,
    },
  } = island;

  const islandImage = islandImageUrl;

  useEffect(() => {
    if (isFinishedFetching(rewardPositions)) {
      setRewardImageUrls(rewardPositions.items.map(({ values }) => {
        const {
          gameScore: { chosenReward: { imageUrl = '' } = {} },
        } = values;

        return {
          imageUrl,
        };
      }));
    }
  }, [rewardPositions]);

  useEffect(() => {
    const loadAllRewardImages = async () => {
      if (!isFinishedFetching(rewardPositions)) {
        return;
      }

      const loadRewardImages = rewardImageUrls.map((rewardImage) => loadImage.bind(rewardImage.imageUrl));
      await Promise.all(loadRewardImages);

      setRewardsImageDownloaded(true);
    };
    loadAllRewardImages();
  }, [rewardImageUrls]);

  /**
   * We show a loader until the island images has actually been cached in the browser.
   */
  if (!rewardsImageDownloaded) {
    return <LoadingIndicator />;
  }

  return (
    <IslandScene island={island} islandImage={islandImage} />
  );
};

const mapStateToProps = (
  { rewardPositions, users }: ApplicationState,
  { island: { id: islandId } }: OwnProps,
) => ({
  rewardPositions: getOrFetchRewardPositions(rewardPositions, {
    islandId, include: 'gameScore.chosenReward',
  }),
  user: getUser(users),
});

export default connect(mapStateToProps)(Island);
